import { render } from "./search.vue?vue&type=template&id=37753870"
import script from "./search.js?vue&type=script&lang=js"
export * from "./search.js?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=37753870&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__